const { commonConfig, dataLayerListener } = require('@alfa-bank/assr-common-config');
const { cdnPlugin } = require('@plotva/assr-core-plugins');
const { name, version, dependencies } = require('./package.json');

const { CUSTOM_GTM_ID, CUSTOM_SECOND_GTM_ID, CUSTOM_SERVER_GTM_ID, CUSTOM_YTM_ID, ENABLE_COUNTERS } = process.env;
const SERVER_GTM_ID = CUSTOM_SERVER_GTM_ID ?? 'G-GL0MWXZRS2';

const GTM_ID_CONFIG = {
  'alfabank.ru': CUSTOM_GTM_ID ?? 'GTM-MS8K9L',
  'alfabank.com': CUSTOM_SECOND_GTM_ID ?? 'GTM-WVFQWGZB'
};

const getGTMId = (host) => GTM_ID_CONFIG[host] ?? GTM_ID_CONFIG['alfabank.ru'];

const gtm = (gtmId) => `<script>
	(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
	new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
	j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
	'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	})(window,document,'script','dataLayer','${gtmId}');
</script>`;

const gtmNoScript = (gtmId) => `<noscript>
    <iframe src="//www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0"
        style="display:none;visibility:hidden"></iframe>
    </noscript>`;

// Webvisor включён на всех страницах
const enableWebvisorAllPages = true;
const webvisorPages = [];

const YTM_ADDITIONAL_CODE = '';

const ytm = (url) => `<script>
	(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
   m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
    
     ym(${CUSTOM_YTM_ID}, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:${enableWebvisorAllPages ? true : 'webvisorPages.includes(url)'},
        trackHash:false,
        ecommerce:"dataLayer",
   });
</script>`;

const ytmNoScript = `<noscript><div><img src="https://mc.yandex.ru/watch/${CUSTOM_YTM_ID}" style="position:absolute; left:-9999px;" alt="" /></div></noscript>`;

const ytmCookie = `<script type="text/javascript">
    function setCookie(name, value, days){
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000)); 
        var expires = "; expires=" + date.toGMTString();
        document.cookie = name + "=" + value + expires + ";path=/";
    }
    function getParam(p){
        var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\\+/g, ' '));
    }
    var yclid = getParam('yclid');
    if(yclid){
        setCookie('yclid', yclid, 90);
    }
</script>`;

const ytmSendUserParams = `
    <script>
     (function () {
        function readCookie(name) { 
          var n = name + "="; 
          var cookie = document.cookie.split(';'); 
          for(var i=0;i < cookie.length;i++) {      
              var c = cookie[i];      
              while (c.charAt(0)==' '){c = c.substring(1,c.length);}      
              if (c.indexOf(n) == 0){return c.substring(n.length,c.length);} 
          } 
          return null; 
          }

        function send (platformId) {
          var yid = readCookie('_ym_uid');
          var time = new Date().getTime();
          var ycl_id = readCookie('yclid');

          //параметры визита и параметры пользователя
          ym(${CUSTOM_YTM_ID}, 'params', {
            SessionID_YM: time + "." + yid,
            platformId: platformId,
            yclid: ycl_id,
            ClientID_YM: yid
          });

          ${YTM_ADDITIONAL_CODE}
        }
        // Логика ожидания
        var pid = readCookie('platformId');
        if (pid) {
          send(pid);
        } else {
          window.addEventListener(
            'platformIdReady',
            function handler (e) {
              window.removeEventListener('platformIdReady', handler);
              send(e.detail);
            },
            { once: true }
          );
        }
      })()
    </script>
`;

const ytmSendEvent = `<script>
   var product
   var productDetail
   var pagetype
   var path
   function ytmSendEvent(dlvalues){  
      product = dlvalues.product || product || '';
      productDetail = dlvalues.product_detail || productDetail || '';
      pagetype = dlvalues.pagetype || pagetype || '';
      path = path || dlvalues.path || '';
      var action = dlvalues.action || '';
      var block = dlvalues.block || '';
      var labelDetail = dlvalues.label_detail || '';
      var event = dlvalues.event || '';   
      var newProductDetail = productDetail && productDetail != 'undefined' ? '::'+ productDetail : ''
      var eventCategory = dlvalues.eventCategory || product+newProductDetail;
      var eventAction = dlvalues.eventAction || pagetype+'::'+block+'::'+action;
      var eventLabel = dlvalues.eventLabel || labelDetail+'::'+path;
      if (eventCategory && (event == 'gtm_interaction_event' || event == 'gtm_non_interaction_event')){
         ym(${CUSTOM_YTM_ID}, 'params', { 'event': { [eventCategory]: { [eventAction]: eventLabel }}});
      }
   }
   if (window.DATA_LAYER) { window.DATA_LAYER.subscribe(ytmSendEvent) }
</script>`;

const platformIdReady = `<script>
(function () {
    function readCookie(name) {
        var n = name + '=';
        var cookie = document.cookie.split(';');
        for (var i = 0; i < cookie.length; i++) {
            var c = cookie[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(n) === 0) {
                return c.substring(n.length);
            }
        }
        return null;
    }

    Promise.resolve().then(function () {
        var pid = readCookie('platformId');
        if (pid) {
            window.dispatchEvent(new CustomEvent('platformIdReady', { detail: pid }));
        }
    });
})();
</script>`;

const alfaPartners = (url) => `<script>
(function(d, w, nav, sc) {
  var isPixelSent = false;
  var utmSource = new URL(window.location.href).searchParams.get('utm_source');

  if(!utmSource || !utmSource.includes('alfapartners')) return;

  dataLayer.push({ event: 'alfapartners' });

  function serialize(obj) {
    return Object.keys(obj)
      .map(function(key) {
        return [key, obj[key]].join('=');
      })
      .join('&');
  }
 
  function getCookie(name) {
    var matches = d.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : '';
  }

  function createPixel(product = '') {
    if (isPixelSent) return;

    var query = {};
    var sessionStart = getCookie('gtm-session-start') || new Date().getTime();
    var cid = getCookie('_ym_uid');

    try {
      query.platform_id = getCookie('platformId') || getCookie('GTM_platformId') || 'alfasite';
      query.url = '${url}';
      query.clientid = getCookie('_ym_uid');
      query.sessionid = [sessionStart, cid].join('.');
      query.product = product;
    } catch (e) {}

    var path = 'https://alfapartners.alfabank.ru/pixel/click/';
    var qs = serialize(query);
    var img = new Image();
    img.src = [path, '?', qs].join('');
    img.style = 'position:absolute; left:-9999px;'

    isPixelSent = true;
  }

  function subscribeProduct(dlvalues) {
    if (!dlvalues.product) return;

    createPixel(dlvalues.product);
  }

  if (window.DATA_LAYER) { window.DATA_LAYER.subscribe(subscribeProduct) }

  window.onunload = function () { createPixel() };
})(document, window, navigator, screen);
</script>
`;

const favicon = `
  <link rel="icon" type="image/x-icon" href="//alfabank.st/media/favicon_alfa-logo_32x32_common_28-08-2019.ico"/>
  <link rel="icon" type="image/png" href="//alfabank.st/media/favicon_alfa-logo_16x16_desktop_08-08-2019.png" sizes="16x16"/>
  <link rel="icon" type="image/png" href="//alfabank.st/media/favicon_alfa-logo_32x32_desktop_08-08-2019.png" sizes="32x32"/>
  <link rel="icon" href="//alfabank.st/media/favicon_alfa-logo_192x192_common_09-08-2019.png" sizes="192x192"/>
  <link rel="apple-touch-icon" href="//alfabank.st/media/favicon_alfa-logo_180x180_common_09-08-2019.png" sizes="180x180"/>
  <link rel="mask-icon" href="//alfabank.st/media/favicon_alfa-logo_128x128_common_13-08-2019.svg" color="#ef3124"/>
`;

const config = {
  ...commonConfig,
  postcss: {
    customPropertiesFile: 'node_modules/@alfalab/core-components-themes/site.css'
  },
  cssHashLen: 5,
  widgetsContexts: ['@alfa-bank', '@plotva'],
  instanceName: name,
  instanceVersion: version,
  getDependencies: () => dependencies,
  plugins: [{
    plugin: cdnPlugin,
    config: {
      cdnPublicPath: process.env.CDN_PUBLIC_PATH || process.env.CS_CDN_PUBLIC_PATH,
      domainPattern: '(https?:)?//alfabank[.]st'
    }
  }],
  cdnReplacement: {
    enabled: true,
    viewLog: false
  },
  getCounters: (url, data) => {
    const isCountersEnabled = ENABLE_COUNTERS === 'true';
    const {
      collectorData: { host }
    } = data;
    const gtmId = getGTMId(host);
    const enableYtm = isCountersEnabled && CUSTOM_YTM_ID;
    const ytmScripts = [
      ytmNoScript,
      ytmCookie,
      dataLayerListener,
      ytmSendUserParams,
      ytmSendEvent
    ];
    const headGTM = isCountersEnabled ? gtm(gtmId) : '';
    const headYTM = enableYtm ? ytm(url) : '';
    const bodyYTM = enableYtm ? ytmScripts.join('') : '';

    return {
      headCounters: [platformIdReady, headGTM, headYTM],
      bodyCounters: [
        gtmNoScript(gtmId),
        bodyYTM,
        isCountersEnabled ? alfaPartners(url) : ''
      ],
      endBodyCounters: []
    };
  },
  getFavicon: () => favicon
};

module.exports = config; 
